import { FrontLayout } from 'components';
import { RegistrationForm } from 'components/RegistrationForm';
import { useEffect } from 'react';
import { ROUTES } from 'shared/constants/ROUTES';
import { tokenService } from 'shared/services/tokenService';

const { isAuthenticated, isCompletedPrimaryDetail } = tokenService();
const Registration = () => {
  //redirect to dashboard if user is authenticated and completed primary details
  useEffect(() => {
    if (isAuthenticated() && isCompletedPrimaryDetail()) {
      window.location.href = ROUTES.TALENT.DASHBOARD;
    }
  }, []);
  return (
    <FrontLayout containerWidth={1130} newTalent>
      <RegistrationForm />
    </FrontLayout>
  );
};

export default Registration;
